import React,
{
    useState,
    useEffect,
    useRef
}
from "react";
import {
    FontAwesomeIcon
}
from "@fortawesome/react-fontawesome";

import {
    faChevronLeft,
    faChevronRight
}
from "@fortawesome/free-solid-svg-icons";

import {
    NAV_GRADIENT
}
from "../../../constants/colors";


import {
    OMNISCAN_BLUE
}
from "../../../constants/colors";

import AmChartTreemap from "../../../components/AmChartTreemap";
import RoomAreaList from "./RoomAreaList";
import useSpaceOrgDashboardFloor from "../hooks/useSpaceOrgDashboardFloor"

export default function FloorTool({
	floorId,
    expanded,
    onToggle,
	selectedSpaceTypeId,
	setSelectedSpaceId,
	setSelectedSpaceTypeId
})
{
	
	const {
	      spaceBreakdown,
	      spaces,
		  floorName
	   } = useSpaceOrgDashboardFloor(floorId);
	   
	   
	   const [selectedRoomId, setSelectedRoomId] =
	       useState(null);
	   
	  
	
	const [position, setPosition] =
	    useState(
	    {
	        right: 20,
	        y: 60
	    });

	const [dragging, setDragging] =
	    useState(false);

	const dragOffset =
	    useRef(
	    {
	        x: 0,
	        y: 0
	    });
		
		
		function handleMouseDown(
		    event
		)
		{
		    setDragging(true);

			const rect =
			    event.currentTarget.parentElement.getBoundingClientRect();

			dragOffset.current =
			{
			    x:
			        rect.right
			        - event.clientX,

			    y:
			        event.clientY
			        - rect.top
			};
		}
		
		
		
		useEffect(
		    function ()
		    {
		        function handleMouseMove(
		            event
		        )
		        {
		            if(!dragging)
		            {
		                return;
		            }

					setPosition(
					{
					    right:
					        window.innerWidth
					        - event.clientX
					        - dragOffset.current.x,

					    y:
					        event.clientY
					        - dragOffset.current.y
					});
		        }

		        function handleMouseUp()
		        {
		            setDragging(false);
		        }

		        window.addEventListener(
		            "mousemove",
		            handleMouseMove
		        );

		        window.addEventListener(
		            "mouseup",
		            handleMouseUp
		        );

		        return function ()
		        {
		            window.removeEventListener(
		                "mousemove",
		                handleMouseMove
		            );

		            window.removeEventListener(
		                "mouseup",
		                handleMouseUp
		            );
		        };
		    },
		    [dragging]
		);
	
    const containerStyle =
    {
        position: "absolute",
		right:
		    position.right + "px",

		top:
		    position.y + "px",

        width:
            expanded
                ? "450px"
                : "250px",

        height:
            expanded
                ? "700px"
                : "60px",

        background:
            NAV_GRADIENT,

        borderRadius: "15px",

        boxShadow:
            "0 20px 40px rgba(0,0,0,0.4)",

        overflow: "hidden",

		transition:
		    dragging
		        ? "none"
		        : "all 0.3s ease",

        zIndex: 1000
    };

    const headerStyle =
    {
        height: "60px",

        display: "flex",

        justifyContent: "space-between",

        alignItems: "center",

        paddingLeft: "20px",

        paddingRight: "20px",

        color: "#ffffff",

		cursor:
		    dragging
		        ? "grabbing"
		        : "grab",
		
    };

    return (
        <div style={containerStyle}>

		<div
		    style={headerStyle}
		    onMouseDown={handleMouseDown}
		>

                <div>
                    {floorName}
                </div>

				<FontAwesomeIcon
				    icon={
				        expanded
				            ? faChevronRight
				            : faChevronLeft
				    }
				    onClick={function(event)
				    {
				        event.stopPropagation();

				        onToggle();
				    }}
				/>

            </div>

            {
                expanded
                &&
                <div
                    style={{
                        padding: "20px",
                        color: "#ffffff"
                    }}
                >
				<div
				               style={{
				                   marginTop: "-20px"
				               }}
				           >

						   	
				               <AmChartTreemap
				                   chartId="spaceDashboardTreemapFloor"
				                   width="100%"
				                   height="250px"
				                   chartData={spaceBreakdown}
				                   valueColumn="area"
				                   nameColumn="description"
				                   childrenColumn="children"
								   selectedSpaceTypeId={selectedSpaceTypeId}
				                   onClick={function(id)
				                   {
				                       setSelectedSpaceTypeId(id);
				                   }}
				               />
							   {
							       selectedSpaceTypeId &&
							       selectedSpaceTypeId !== -100 &&
							       (
							           <div
							               style={{
							                   textAlign: "right",
							                   marginTop: "-5px",
							                   marginBottom: "10px"
							               }}
							           >
							               <button
							                   onClick={
							                       function()
							                       {
							                           setSelectedSpaceTypeId(
							                              null
							                           );
							                       }
							                   }
							                   style={{
							                       background:
							                           OMNISCAN_BLUE,

							                       color:
							                           "#ffffff",

							                       border:
							                           "none",

							                       borderRadius:
							                           "20px",

							                       padding:
							                           "4px 12px",

							                       cursor:
							                           "pointer",

							                       fontSize:
							                           "11px",
													   marginTop:'6px'
							                   }}
							               >
							                   Clear Space Type
							               </button>
							           </div>
							       )
							   }
							   <div style={{marginTop:'20px', marginLeft:'10px', marginRight:'10px'}}>
							  <RoomAreaList
							  	rows={spaces}
								selectedRoomId={selectedRoomId}
								selectedSpaceTypeId={selectedSpaceTypeId}
							    onSelect={
							        function(room)
							        {
							            setSelectedRoomId(
							                room.id
							            );
										setSelectedSpaceId(
							                room.id
							            );
							        }
							    }
							  />
							  </div>
				           </div>

                </div>
            }

        </div>
    );
}